import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { Button } from './ui/button';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      onClick={toggleTheme}
      variant="outline"
      size="icon"
      className="w-10 h-10 rounded-full transition-smooth glass-effect"
      style={{
        borderColor: 'rgba(249, 115, 22, 0.3)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.borderColor = '#F97316';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.borderColor = 'rgba(249, 115, 22, 0.3)';
      }}
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <Sun size={18} style={{ color: '#F97316' }} />
      ) : (
        <Moon size={18} style={{ color: '#F97316' }} />
      )}
    </Button>
  );
};

export default ThemeToggle;